// @ts-ignore TypeScript does not natively allow "*.ts" syntax and fails during build.
// eslint-disable-next-line import/extensions
import * as RAW_CONFIGURATIONS0 from './crypto.ts';
import * as RAW_CONFIGURATIONS1 from './dpasa.ts';
import * as RAW_CONFIGURATIONS2 from './index.ts';
import * as RAW_CONFIGURATIONS3 from './kalk3.ts';
import * as RAW_CONFIGURATIONS4 from './kalkai-ch.ts';
import * as RAW_CONFIGURATIONS5 from './laser.ts';
import * as RAW_CONFIGURATIONS6 from './local-crypto.ts';
import * as RAW_CONFIGURATIONS7 from './local-dpasa.ts';
import * as RAW_CONFIGURATIONS8 from './local.ts';
import * as RAW_CONFIGURATIONS9 from './production-ch.ts';
import * as RAW_CONFIGURATIONS10 from './production.ts';
import * as RAW_CONFIGURATIONS11 from './qa.ts';
import * as RAW_CONFIGURATIONS12 from './sage.ts';
import * as RAW_CONFIGURATIONS13 from './staging.ts';
import * as RAW_CONFIGURATIONS14 from './unbounded.ts';
let RAW_CONFIGURATIONS = { "crypto": RAW_CONFIGURATIONS0, "dpasa": RAW_CONFIGURATIONS1, "index": RAW_CONFIGURATIONS2, "kalk3": RAW_CONFIGURATIONS3, "kalkai-ch": RAW_CONFIGURATIONS4, "laser": RAW_CONFIGURATIONS5, "local-crypto": RAW_CONFIGURATIONS6, "local-dpasa": RAW_CONFIGURATIONS7, "local": RAW_CONFIGURATIONS8, "production-ch": RAW_CONFIGURATIONS9, "production": RAW_CONFIGURATIONS10, "qa": RAW_CONFIGURATIONS11, "sage": RAW_CONFIGURATIONS12, "staging": RAW_CONFIGURATIONS13, "unbounded": RAW_CONFIGURATIONS14 };
const CONFIGURATIONS = Object.fromEntries(Object.entries(RAW_CONFIGURATIONS)
    .filter(x => x[0] !== 'index')
    .map(([k, v]) => [k, v.default]));
export default CONFIGURATIONS;
